import { render, staticRenderFns } from "./SGKEksikGunCreateOrUpdate.vue?vue&type=template&id=f0d4e9d6&"
import script from "./SGKEksikGunCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SGKEksikGunCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports